<template>
  <div class="index-page page-main">
    <div class="header">
      <van-icon class="icon" name="arrow-left" @click="toBack" />
      {{ title }}
    </div>
    <!-- <div class="content"><img :src="titleImg"></div> -->
    <div class="content">
      <div class="mp3">
        <div class="mp3-title">讲解</div>
        <div
          class="icon"
          :class="{ pause: isPlay }"
          @click="changePlayStatus"
        ></div>
        <van-slider v-model="value" active-color="#ff6138" :max="1" :min="0">
          <template #button>
            <div class="custom-button"></div>
          </template>
        </van-slider>
        <div class="time-box">{{ currentTime }} / {{ totalTime }}</div>
      </div>

      <div class="main" v-html="content"></div>
    </div>

    <audio
      class="hide"
      :src="mp3URL"
      @loadedmetadata="loadedmetadata"
      @timeupdate="updateProgress"
      controls
      ref="audio"
    ></audio>
  </div>
</template>
<script>
import api from "@/api/api";

export default {
  props: {},
  data() {
    return {
      phone: "",
      coupon: {},
      value: 0,
      currentTime: "0:00",
      totalTime: "01:05",
      content: "",
      title: "",
      titleImg: "",
      isPlay: false,
      mp3URL: "",
      audio: {},
      currentSecond: 0,
      totalSecond: 100,
    };
  },
  async created() {
    // this.id = this.$route.query.id;
    // console.log(this.$route.query.id);
    if (this.$route.query.id == undefined) {
      this.id = 2;
    } else {
      this.id = this.$route.query.id;
    }
    this.getDetail();
  },
  mounted() {
    this.audio = this.$refs.audio;
  },
  methods: {
    toBack() {
      this.$router.back();
    },
    updateProgress(e) {
      this.currentSecond = e.target.currentTime;
      this.value = this.currentSecond / this.totalSecond;
      this.currentTime = this.timeFormat(e.target.currentTime);
    },
    loadedmetadata(e) {
      this.totalSecond = e.target.duration;
      this.totalTime = this.timeFormat(e.target.duration);
    },
    changePlayStatus() {
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        this.audio.play();
      } else {
        this.audio.pause();
      }
    },
    async getDetail() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      const data = await api.getDetail(this.id || 1);
      if (data.code === 200) {
        this.$toast.clear();
        this.content = data.data.content;
        this.title = data.data.titleName;
        this.titleImg = data.data.titleImg;
        this.mp3URL = data.data.describe;
      }
    },
    addZero(value) {
      return value < 10 ? `0${value}` : value;
    },
    timeFormat(value) {
      let time = "";
      let h = this.addZero(parseInt(`${value / 3600}`));
      value %= 3600;
      let m = this.addZero(parseInt(`${value / 60}`));
      let s = this.addZero(parseInt(`${value % 60}`));
      if (h > 0) {
        time = h + ":" + m + ":" + s;
      } else {
        time = m + ":" + s;
      }
      return time;
    },
  },
};
</script>
<style lang="less" scoped>
.index-page {
  background-color: #f9fbff;
  height: 100%;
  box-sizing: border-box;
  max-width: 7.5rem;
  margin: 0 auto;
  font-size: 0.36rem;

  .header {
    width: 100%;
    height: 1.12rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 0.36rem;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 0.02rem solid #f0f0f0;

    .icon {
      margin-right: 0.16rem;
    }
  }

  .hide {
    display: none;
  }
  img {
    max-width: 100%;
  }

  .content {
    padding: 0.24rem 0.36rem 0;

    .mp3 {
      background: #fff;
      border-radius: 0.16rem;
      box-shadow: 0 0.08rem 0.2rem 0 #0000000f;
      height: 1rem;
      padding: 0 0.36rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .mp3-title {
        color: #ff6138;
        font-size: 0.28rem;
        margin-right: 0.32rem;
      }

      /deep/ .van-slider {
        flex: 1;
      }

      /deep/ .van-slider__button-wrapper {
        width: 0.28rem;
        height: 0.28rem;
      }

      .custom-button {
        background-color: #fff;
        border: 0.04rem solid #ff6138;
        border-radius: 50%;
        box-shadow: 0;
        cursor: pointer;
        height: 0.28rem;
        position: absolute;
        transition: border-color 0.3s, box-shadow 0.6s,
          transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
        width: 0.28rem;
        box-sizing: border-box;
      }

      .icon {
        background: url(data:image/png;base64,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);
        background-size: 100% 100%;
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.32rem;

        &.pause {
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAE9xJREFUeAHlnF2MHNlVx8+tW9XVPR/2+GvxbrzxYidB2IhICUILQrACvwBKpBVK4AWJh7Ak4Q2EFMTDesUDEQ9IPEAg4oUoSECAPCDEA1GkTZQNX0uEwCuySZzNetfrxLv22DM9/VFf/P63umZqxj0z7Y+NPeMrVVfX1+37//c559577jnl7B6VqqrctlU999z0axcuTD+/taKzZ6utp8Lxs89OP89F59y216bWtc3J2Rq4zcMzk9Im4kNU9oWL0aYqrw+nt+NQdzPIc6dK+1zryTZxbxNZ0xvWasO0r9sS05aUhpQ2ISLi+MjZyglnffbDsbNH9QuP1T8z4JxKL50Qc9nsDY67ncrmObf4WmVX2DfEtQmbgaw7karbImhmYtqkXLoR2Q9AyCHA9486i1ciG2aQNKylaL5w1mNTGZf1vhPVBA18ZX02lcVuad2ksnyxtPk3K7sOUd+FsMcPluF6Q9Y9JmpmgqaS00hMIy1nrzq7vOIsSMo7IWM5sjcXI0v6USDk6Diy8YIzn0aWQcqQ4xxSjs0bpG1Wu25S2tW+WQxZ3U5pCUQVo9I6q5W9ybEIy+ZLO7pSWr5U2pVXa8l6bLGyC8dqUhuypqjfrNK0K0E7EqO/TuS0iZk/FllxzdviYWc3BpEdWPO2fMRbDBm9kbe866waeysgZjF1NoojKyeSE0Sh9RFBTpqXtjKqzPPddQqLh5UN0sJySFp6q7Cbc4Ud7HHPNe45XFj/ahlUsCGqIUnV3gFROxK0IzkiplElSYyI6aA+MRKzthxbOfRWHfaBlH7srQspjmvZYM68e9JcdNZK926z6l3mqqNWWY++p1vTUw3N2cAq9ybnvmlR9Q2rygtWVP9qSW/NKqRmCFnzeRHIctcKi7qFzS3llnNtjBo2RG1VvdskaVuCdiWnkZpLj0T2+Pe8DY5gS96KbehjqyDEVUkgpZyHqOwYBDxtVfWLEPBDbGP64S7HcU3ILp/O5dw75K4O29d59p8g8PPmkqsW9YtAVuUycxDWLXLaktOWyi49UtC20rZK022QNJWgW8hp2xpJzUvYmgtXIzuL1HwLdUqQDFcmVooY9vEwtrwH+PwnkICPQc6PISmyCxMJ4dvdFchyDpL+k3o/haH6qsUDpKcLkVFmEURpnyFNp1G7C6jd2WOlncE2aZjQqN0WoqbZpVsI2pEcSY3KBYg58Zq311Jvh1a8rSwmlvZjGpyYSxME5KfMot+BmFPcjepw5e0pIn1A7ReR2D+0KvmKVaOM381sNJ/b4kpm1xcLOzEq7LUTBbay7vFkxGckaVPDdyVHPVSjUle63hZcbB6JSdiXRcfS6FHLqmetrH6aRouY71/BdFvkvkRbnrNR+YZFfkxbciuQpFX2x4fFrCrXlqR1gmYiJ8XejLA3aRzbDWxMxOZ62BpIWrNziPYfwYjsBFJ0X0rGr45R9d+yOfuCDSGnGmR0BpkdZBvluaXYpdHudqkhaTpBbZvTGGORs/x6bEs9v05OmXYsylLMwW/QsI+zfX+lZvv/YMClP8Xs/bmVyciiEaRNSFoeFLb0jnw3kjYRtEl6diKnl8QM2GLrIzk+SS3PFiyKP4mh/LkHiJyaNodMV+6LVuafsDhZtSIb2TwkZerlsnxWkqJN5DT/SHvw16jVEHKkOhm2puu7VkbHzfu/xdace+DIEY4KJVPb1Ea1VW1W24VBWIKpQCtkV6UlzWxAz06KuHGbCJL0TCOnj83xGtfwAwVqxcyIgdvf0AgGevfN3jQ4dtszPrJvMDD9ZW5cMY+6DTHgBdI0v41NanX/G/OfRrU0zlG5fsrZFeZS+aq3A4kPBlnkVAzwiuqTky78fhnjuo2zfdJGd6pus9ouu8mfLUzCJozCqtJgb7jgVE1Qc0LSo0Hg5fcwdWAgeOymt/JRb6v0Uh0qjmOkp3iGMcfP8uy9GvSpaW9vqapu3WbaLgzCIkzCJozCKsxhADxx4k042ZCgtmqNX/ZhXnX5GIO/G1Qk3aXCcX4OyfkYaB6U3up2iO2FtguDsAiTsAmj5pDCPMUe+fPO1SQ9heRcXWOGfSKy16/jolCPNWKEPJdYkafWiU4wA/9LWjR3O616wO5F3aqnLHb/iJtlFWylebwDhm9pNa/s9Em+r1X2FO6Xq4+YPf/8hJy2ar2CuJ3sR5YyOu6wFasdyOowKv09wMpA7/VSYxEmYRNGYRVmYd+iav78MeZV64PBAoPFjTfomcY5BEWp+Q4VGXOrSqqV7nV2aL9nw8fr/ofx0SUGk5WtjEu7zmnG3LY0Nlu+bnY6Z87ZnxhpoZYlXxng3WMCeqDjqSYJM/KylGH+be7Yi3ZHyKYVsIBJ2OR1EFZhFnZx0PRqPLkhPcdXXTBW8gJ6vH9dXBd+hIpVT9K1n5r2K3v6nDAJmzAGrGAWdhlscTEx2LWBbhi7jl+nYnwwjmIMGT1YwmQ0+nUGWnunS5/1XxOmgA2MwirMwi4OVCacxIGp4z18w8zSO/iH53NvGjnnPNTLHqFrfB+3r09qw8P74wPfONgcGFfd6zjYYlvA6daPme3j4zqO5UWKmF+9H7iXcDuxFJNgpFfQwzmPm9ThWC8+yEU5pe6+MMe1p58x+8mfr+t64Z/NPv9pTAHGcKdyp8/tVOf6NQx0YR+0jv80HgnsD9YoHUU2YBEhdEfvN3/+A6di+x5rV8tIzQJbN9P0AV+PT7Hpn+D7ZFVvvdY7+/JLHzX7hV9l/M0wStu734unlJ966T92ru9On9u51uYq/5o7gIr9A+7hnLlmQeNKu8aKri9LezzCSL+FQdKi3sm8Xq/qLzJHkWSNQVG9p6nprveN5LQrmnaufV3fp90z7dzW52Y+FkawCrOwa81OXIgTuKkNkhb3ViRaWPL5HEseoV7RjyN2o5l/Z7cbl47eese0c1vvmnbPtHNbn5v1WBiFVZiFXRyIC3FC4YB+X2vkWv71rG6OuSkruRj9MNf3X+91K3FgBKswC7s4EBfiBG7iIEpRxLp5jxu4OAdpnYTv1WlGmajaPi/C6NxpS32Nfw2SSrhYpNM6WE5UTBxorXyhw0109Tk3VxD0sBRhFWZhFwfiYlKiEHGhSIvunAvr5fMJC3J092ZHmpsegv2RgFnYFTMgLsQJ0Si3qlAGOS5Eiz0M9qf57/Gxg7kIgtGcC3usNt2ZYnQUipLAniItdPP+mLlvArvDAWM+MAu7OBAX4gRu6m7elupnJV6xbozXdXCHSvfXJWEWdnEQSs0J0V8cjRkY2cIEMN6Nuty7MVBT44O7n2BtsMOFOIEbYnno71XwMgaXj4KW6qJwk4el1FgDdlxFgQugw02tYp0YUlaZOCJeg/WI02sPCzvgrLEKe1AxuAicSILaZYz0eOKLUzbnLrYv7evvwirMwi4OWmWjm48JklTAJAsiVhUlHqBvM9NVZNfGPa0H981XRa8JqzAnvhR6w3VmEy8MUwtikFX6bJ5gSemhtsr+D3L2v6EWRmFtcIsDcaECN5F9ly+LRIn2CLFVJGme4URC1DL7Glcas67b764sE4+5tUw7N8s9szy3tZ7tj1kGAqswC7s4EBfiBG4mNggbtUINZUzM8RjpGaBiMVGm9q3t673NK/Igbi3Tzs1yzyzPba1nu2NhDFjBLOziQFxM7LY//+SZxEaMpjsRs1hm86Uc9rhcfaFZ7gFI+lHuvns79HUEUh7EY+8gaHzN7It/X7tcqzpscLv2250+t22F7QtuiJP17ywuvmaOiI+ciA9XZJYmuY19Yeli6apnPoA3jUhVRacWeScERimCw1esZReP8RDhtvdQ1drtu9/f6bMYPT8NOZdRMYJBCTVWoJWPxyFKNj7M5Ex5D8qBKNLSCsL/FaDtSsJosepF8haBkf8Njk1d3/3GdY9+n84IbMIYem0wC7s4EBfiBG42xkEaGOUYp/QGHR3h/47lD7zTUPMZtv03qhYmYRNGYRVmYRcHk0Gi/gjW4olsWKGrT1cIWiP/QUbKJTA54kFYde5FAo5evUf/2oNTjTAJmzAGrGAWdnEgLsQJ3OBa7NGtQVIfCZJoOXIeyox8Bz0Au2K4jP4MZPtJioZg+lSNDXwBK5iFXRyIC3ECN7WKNXZIojVkRJ2UuS0oCBspUsyDS/4dQ/1vbLus8j04ArJtS4QhYEm0IJcFjMIqzMIuDib2R3VEdmShTk5r1GxpkkEzYhHNd5AeKqxyArTdH3M/sSF7voABLMIUNASMwqoUK2FvqZe4IWDoUBClkB0j0RqwaV6WkBgi0fOwK6Zzd4Vg7N9Hb/euqqntwiAswiRswiiswizsQb3IFJLpgRtU7MVaJOYxSsrgW2REqWwZBRUpg4bVfdbpM+KMNT74Mjd/hm0vkqQ202uBQViESdiEUViFWdjFgbgIhf4p5FJdQc2U1tg21ou9wjJJ0RpdYJbhp80tKhRf/FdU/hUkae9MZNVWtVltFwZhESZhE0ZhbRvnkOIJJ+SZ1Ub60MWaMRnrRoo8jDp0s9tDgrrkYEWyP+htRO6DJ046dP17wWjLZfNqaLPaLgzCIkzCJozCui49cKAy4SQKCbDKyNsqRdJHB7NDHk7JwSJdLbDf4R+oCiZT5IOZfEb24EpSLeW0UblrtFltlwQJizAJmzCu2x669pb0iJtaglqM2ZgsPUlRlJETqlEliWkagqdD0onEfj62ROmR1VWr/G8G0X0wbRIG2Uiwo41qq9qstguDsAiTsAmjsAqzsLe54Ls//+EPk5+Bh0hRncuncBIRK71wE/vVYRkE7/W47xBJbmVCr9dPeM6XaBvL+crMwgv5gi5gk87UN+kX7nOpe9rPolZ/QlDCwDrliMBx8mRRq7JCrVL+aDyJXLT0ICpWVmRn41FEk0aPk+NK6vkkK7F2Yyg98cwFUL3MRrriKwMGTGQOD6+JJNi96Wwuzm2NPFEyiegW8R1BNgPP0J8lyWcR4e8wG/5dKiCf4x64R+6E43ogiwlwf8Af+mWWbrAzkFPRa0UJGYhIkPLGunTva0hOcoA08pu09nCp5Cl7AsNsL8OF8u7r94VE67nkn5u06DIGW2OARtVydfvkpnt0tcNoUz+gH8owdFk8DKIr8S3tS0jRr9G4r1LT/RgGMPnkt9UGtUVt0qY2hrZOyBEGYREmYWtUK4x7Jp1VwwVZPxuOMEnRBaToLPAuI2aLl8iBXy4JJEJiUMGShbRIJA1QLVQuQSwLDLkRwl8hTjFqlvk3ENfzDOUJfCw/QoPfSW2K9pusVvLt3hZ+H6vi1KNGf8HvvRjISNSRyA5UqJVnrKM/FJUSOcJQyu5Utd2p39wwUS00p53wS+Ub+WJNxs+ZScaPMpsVL6zXS3iirUY3mLYSJlsQP10O6lBhJfMWJIUojJYYWlhjY19V+LI9+9H7cDz9Cr/zI1CkhYAQGnnXHBGTS10i/X+Zjf81Y5j/wiuIbXGQogEgYxztc1TJT5J7G3LUpccYZdmeAqPc9FrKiJZqvTR5Fc8kZ2yDILVaJLWzfh4j+l75C80bFTyB1ltJUmxfooDzLmHD2J5yRD5Wh7hjD3EF8f0iKlMozTm2nwHYD7LXiwVSiNyQYE5uW+oXC2g4QYZOGFo8DzH/gnDiTIeYHPeouvBSg9l0TP4zxAxzy1KmEJC0lZwCh3zzhoYnyKeXWWm/fKCVULeZILVwVpIigh0LSRIE6V0cnr3IUu58Rbyf3rwQcYyiIvZIHftE3eGQ4FD/Xo7fhUqcROJOcu8h/nFJV7OKIvXQ6JekCSfj/x3q+SZk4N3srtH5oCKQkODL0YSzhITw5gWOtR4jUgo2veujw142R2olybkNckRHrOzeTWmZOrvJHl00e4IXG72iC7j7544woevj/Uc6UGmiQlEdjSFoAJ5+i0nizwpy6WlUQVB6PT4gvJgYwIKFgKKD9JTM6dwLiD+Kx9CB4blqv6W4CB8NyzFlwYbNqHBmebrmLqSMuSZyMLXBwZeTzdxBrQqkZszoOGJ2zg+G3irSMc/P8yqdm0xE9W6PaZKzpQHiZt14biKpsUfT1E3hsc0rb2Ji+Yp+HToruxQpfI3XUkQJdguJGUJQxQsIOtqzOYX2SbogROTkIk3fCT2pY5I2mhhBTEEH4CEiZisgqRJhkhL85XKTjtkcLwzoshdRcvRpZl5q8qk/iD/NM0xpeisZZHlQtyOnrVr6YyjTCdKV7UhSXHX7vUDzBwBK6H4flVMSjIek8OYXlo4ihdVmEAQpEQsE2Rz2DKI8f0zOsWJyOhDUkNPsRY6K9pKUCKJiloW1uCdSEgZ1JcdjyOpNXKWaU+kNMAXkFEiaRsgxr6XQOEddefOeIfm/ttoc/VaLHB1uypvXCZVNUqQT00hSkod6N4UPd+jdmjdKlfRwPYYC6uUUa5yS/yGiOkSMrE3IkvQoSElkKYoi07uDOCYlrRXZVhOjpeAxpkgkJTjUteIpUnKOJUXBfwwpCjYQMSO66J5UkF5KcytNH5o3VmlMp3GO5puahLYNsnBuQ44urUuQDlR2JUk3KSsvZZwkkhqVWyTOSL3cCmrnCcRu3jIlqZLq6U1TkqiClyqFPcciKWHqEkJOqLeALBVFWYQ94DNWO0VOIAinutbORY4CLaRKkpbm7VRyWWhWLkMsD2mjUiInTCEYJau0xzo7kKNbbyFIJ3ck6UPcEDKjScjXMEAq10iT4h31Oq55JElESaKkel3F+0mq2OdIVkd7yNEmCWty9RqiREYoYVCKenGsbYzXL0ZSRuwlLfIhS5UkMSJG3kCpk/xajdS0VeoOXo/z/4kZJN4xl9ZxAAAAAElFTkSuQmCC);
          background-size: 100% 100%;
          width: 0.6rem;
          height: 0.6rem;
        }
      }

      .time-box {
        margin-left: 0.32rem;
        color: #989898;
        font-size: 0.28rem;
      }
    }

    .main {
      word-wrap: break-word;
      background: #fff;
      border-radius: 0.16rem;
      box-shadow: 0 0.08rem 0.2rem 0 #0000000f;
      color: #2f2f2f;
      font-size: 0.32rem;
      font-weight: 400;
      letter-spacing: 0;
      line-height: 0.56rem;
      padding: 0.24rem;
      word-break: break-all;
      margin-top: 0.24rem;

      /deep/ img {
        max-width: 100%;
      }

      /deep/ p {
        word-break: break-all;
        word-wrap: break-word;
      }

      /deep/ video {
        max-width: 100%;
      }
    }
  }
}
</style>